import { render, staticRenderFns } from "./MKoreanCartNew.vue?vue&type=template&id=cda4bd5e&scoped=true"
import script from "./MKoreanCartNew.vue?vue&type=script&lang=js"
export * from "./MKoreanCartNew.vue?vue&type=script&lang=js"
import style0 from "./MKoreanCartNew.vue?vue&type=style&index=0&id=cda4bd5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda4bd5e",
  null
  
)

export default component.exports